import { variables } from 'config';
import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  root: {
    minHeight: `calc(100vh - ${variables.headerHeight} - ${variables.footerHeight} - 40px)`,
    width: '100%',
    borderRadius: 'unset',
    backgroundColor: theme.palette.primary.mainBackground,
    color: theme.palette.primary.main,
    flexGrow: 1,
    display: 'block',
    textAlign: 'start',
    padding: '24px',
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
    overflow: 'hidden',
  },
  cardContent: {
    display: 'block',
    textAlign: 'start',
    '&:last-child': {
      padding: '24px',
    },
  },
  button: {
    backgroundColor: theme.palette.primary.mainBackground,
    boxShadow: 'unset',
    color: theme.palette.primary.main,
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#eff2f5',
      color: theme.palette.primary.main,
      boxShadow: 'unset',
    },
  },
  rowKey: {
    fontWeight: 'bold',
  },
  rowValue: {
    fontWeight: '400',
  },
  avatar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  avatarIcon: {
    width: '84px',
    height: '84px',
    marginBottom: '12px',
  },
  editButton: {
    marginLeft: '5px',
    textTransform: 'none',
    padding: '5px 30px',
  },
  accountDetails: {
    width: '55%',
  },
  actionsButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  cancelButton: {
    textTransform: 'none',
    marginLeft: '16px',
  },
  rootDrawerOpen: {
    maxWidth: `calc(100% - ${variables.drawerWidth} - 64px)`,
  },
  rootDrawerClose: {
    maxWidth: `calc(100% - ${variables.closedDrawerWidth} - 64px)`,
  },

  primaryIconButton: {
    textTransform: 'none',
    '&.Mui-selected': {
      fontWeight: '600',
    },
  },
  tabList: {
    width: '100%',
  },
  container: {
    padding: '24px 24px 16px 24px',
    backgroundColor: 'white',
    borderRadius: '4px',
    boxShadow: '0px 2px 8px rgb(0 0 0 / 5%)',
    width: '100%',
  },
  subscriptionTitleText: {
    fontWeight: '500',
    fontSize: '25px',
  },
};
